import React, { useState, useEffect } from "react";
import {
  useQuery,
  useMutation,
  useQueryClient
} from 'react-query'
import { useParams } from 'react-router-dom';
import * as api from "../../../actions/api";
import EntryeditofContractItemsFormData from "./EntryeditofContractItemsFormData";

const AddEntryeditofContractItems = (props) => {
//console.log(props.match.params.id);
  //get DispensingLanguage
  const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
  const lan = localStorage.getItem('LangCode');
  const menukey = "entry-edit-of-contract-items";
  const UserInfo = sessionStorage.getItem("User_info")
  ? JSON.parse(sessionStorage.getItem("User_info"))
  : 0;
  const UserName = UserInfo==0?'': UserInfo[0].id;
  const FacilityId = localStorage.getItem('FacilityId');

  const [formData, setFormData] = useState({
    ContractNo:props.match.params.id, //Get the url send id
    ItemCode:"",
    ItemQty:"",
    ContractUnitPrice:"",
    FacilityCode:"",
  });

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  // const { isLoading, mutate } = useMutation(api.saveContractItem, {
  //   onSuccess: (data) => {
  //    // console.log("data: ", data);
  //     if (data.status == 200) {
  //       props.openNoticeModal({
  //         isOpen: true,
  //         msg: data.message,
  //         msgtype: data.success,
  //       });
  //       queryClient.getQueriesData("ContrackItemEntry"); //api page name
  //       props.history.push("/entry-edit-of-contract-items"); //
  //     } else {
  //       props.openNoticeModal({
  //         isOpen: true,
  //         msg: data.message,
  //         msgtype: data.success,
  //       });
  //       queryClient.getQueriesData("ContrackItemEntry"); //api page name
  //       props.history.push("/entry-edit-of-contract-items"); //
  //     }
  //   },
  // });


  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    console.log("formData: ", formData);
    data[name] = value;

    setFormData(data);

    setErrorObject({ ...errorObject, [name]: null });
    api.dirtyModeEnable();

  };

    //====== Start Choosen Dropdown===========
    const handleChangeChoosenProps = (name, value) => {
      let data = { ...formData };
      data[name] = value;   
      setFormData(data); 
      setErrorObject({ ...errorObject, [name]: "" });
      api.dirtyModeEnable();
    }
    //====== End Choosen Dropdown===========
    

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
    api.dirtyModeEnable();
  };

  const handleReset = () => {
    setFormData({
      ContractNo:props.match.params.id,//Get the Url Id
      ItemCode:"",
      ItemQty:"",
      ContractUnitPrice:"",
      FacilityCode:"",
      
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["ItemCode", "ItemQty","FacilityCode"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = (DispensingLanguage[lan][menukey]['field is Required !']);
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  function checkValidateForm(){

     
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName,}; 
   
    return fDtat;
    }else{
    return false;
    }

};

  // const handleSubmit = async (e) => {
  //   console.log("from submit ", formData);
  //   if (validateForm(formData)) {
  //     let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName,}; 
  //    // alert("hello");
  //     mutate(fDtat);
  //    // swal("Success!", "", "success");
  //   }
  // };

  return (
    <>
      <EntryeditofContractItemsFormData
        errorObject={errorObject}
        addProductForm={true}
        formData={formData}
        handleChange={handleChange}
        handleChangeChoosenProps={handleChangeChoosenProps}
        handleCheck={handleCheck}
        handleReset={handleReset}
        checkValidateForm ={checkValidateForm}
        // handleSubmit={handleSubmit}
        bStockUpdate={props.permissionType}
        {...props}
      />
    </>
  );
};

export default AddEntryeditofContractItems;

